import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "lg:w-[50%] md:w-[60%] sm:w-[70%] bg-gray-100 flex flex-col"
};
const _hoisted_4 = {
  key: 0,
  class: "pt-4 pl-16"
};
const _hoisted_5 = {
  key: 1,
  class: "pt-6 ml-16 text-sm"
};
const _hoisted_6 = {
  class: "pl-4 lg:w-[50%] md:w-[40%] sm:w-[30%] bg-white flex flex-col justify-between"
};
const _hoisted_7 = {
  class: "px-2 py-2"
};
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-start"
};
const _hoisted_9 = {
  class: "scrollable-container p-2"
};
const _hoisted_10 = {
  key: 0,
  class: "px-4 py-2"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "px-4 py-2"
};
const _hoisted_13 = {
  class: "text-base py-2 flex items-center"
};
const _hoisted_14 = {
  key: 0,
  class: "ml-2 flex items-center text-xs"
};
const _hoisted_15 = {
  class: "w-full"
};
const _hoisted_16 = {
  class: "px-4 py-2"
};
const _hoisted_17 = {
  class: "flex space-x-6"
};
const _hoisted_18 = {
  class: "flex-1"
};
const _hoisted_19 = {
  class: "text-base py-2 flex items-center"
};
const _hoisted_20 = {
  key: 0,
  class: "ml-2 text-xs text-gray-500"
};
const _hoisted_21 = {
  class: "w-full"
};
const _hoisted_22 = {
  class: "flex-1"
};
const _hoisted_23 = {
  key: 0,
  class: "mb-4"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  key: 1,
  class: "mb-2"
};
const _hoisted_26 = {
  class: "text-sm text-gray-600 mb-3 mt-3"
};
const _hoisted_27 = {
  class: "text-base px-4 py-1"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = {
  class: "px-4"
};
const _hoisted_31 = {
  class: "flex flex-row px-4 space-x-4 py-2"
};
const _hoisted_32 = {
  key: 3,
  class: "flex flex-row px-6 space-x-4 py-2"
};
const _hoisted_33 = {
  class: "px-4 py-2"
};
const _hoisted_34 = {
  key: 0,
  class: "px-4 bg-gray-50"
};
const _hoisted_35 = {
  class: "text-base py-2"
};
const _hoisted_36 = {
  class: "flex flex-row px-4 space-x-4 py-2"
};
const _hoisted_37 = {
  class: "flex flex-col px-4"
};
const _hoisted_38 = {
  scope: "col"
};
const _hoisted_39 = {
  class: "flex flex-row space-x-4 py-2"
};
const _hoisted_40 = {
  key: 4,
  class: "px-4 py-2"
};
const _hoisted_41 = {
  class: "flex flex-row space-x-4 py-2"
};
const _hoisted_42 = {
  key: 5,
  class: "px-4 py-2"
};
const _hoisted_43 = {
  class: "flex flex-row space-x-4 py-2"
};
const _hoisted_44 = {
  key: 0,
  class: "text-sm text-gray-500 py-1"
};
const _hoisted_45 = {
  key: 6,
  class: "px-4 py-2"
};
const _hoisted_46 = {
  class: "py-2"
};
const _hoisted_47 = {
  class: "px-4 py-2"
};
const _hoisted_48 = {
  class: "flex flex-col px-4 py-4"
};
const _hoisted_49 = {
  class: "flex py-1"
};
const _hoisted_50 = {
  key: 7,
  class: "px-4 py-2"
};
const _hoisted_51 = {
  key: 0,
  class: "grid grid-cols-2"
};
const _hoisted_52 = {
  key: 1,
  class: "grid grid-cols-2"
};
const _hoisted_53 = {
  key: 2,
  class: "grid grid-cols-2"
};
const _hoisted_54 = {
  key: 1,
  class: "p-2"
};
const _hoisted_55 = {
  class: "fab-container gap-2"
};
const _hoisted_56 = {
  key: 0
};
const _hoisted_57 = {
  key: 1
};
const _hoisted_58 = {
  key: 2
};
import { computed, onMounted, reactive, ref, watch } from 'vue';
import draggable from 'vuedraggable';
import Loader from '@/components/Loader.vue';
import LlButtonToggle from '@/components/LlButtonToggle.vue';
import InvoiceTemplateTable from './InvoiceTemplateTable.vue';
import CustomFields from './CustomFields.vue';
import TableFields from './TableFields.vue';
import MatterCustomFields from './MatterCustomFields.vue';
import ServiceAndExpenseSettings from '../OtherPages/ServiceAndExpenseSettings.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSwitch from '@/components/LlSwitch.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlTextarea from '@/components/LlTextarea.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import SubscriptionCtaModal from '@/components/modals/SubscriptionCtaModal.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import EventTracker from '@/services/eventTracker';
import { useInvoiceTemplateStore } from '@/services/useInvoiceTemplateStore.js';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useInvoiceEmailStore } from '../../useInvoiceEmailStore.js';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { storeToRefs } from 'pinia';
import { updateOrder } from '@/services/utils';
import imageUtilities from '@/services/imageUtilities.js';
import fileUtilities from '@/services/fileUtilities';
const invoiceDescriptionMaxLenght = 4095;
export default {
  __name: 'UpdateInvoiceTemplateModal',
  props: {
    selectedInvoiceTemplate: {
      type: String,
      required: false
    },
    state: {
      type: Object,
      required: true
    },
    serviceExpensePage: {
      type: Boolean,
      required: false,
      default: false
    },
    tracking: {
      type: Object,
      required: false
    },
    isTrainingFlow: {
      type: Boolean,
      required: false,
      default: false
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  emits: ['closeDialog', 'open-subscription-modal', 'open-onboarding-call-modal', 'close-draft-modal'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const meStore = useMeStore();
    const invoiceEmailStore = useInvoiceEmailStore();
    const companyStore = useCompanyStore();
    const invoiceEditorStore = useInvoiceEditorStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const {
      features,
      terms,
      company
    } = storeToRefs(meStore);
    const {
      companySettings,
      name
    } = storeToRefs(companyStore);
    const {
      tableFields,
      customFields,
      invoiceTemplateLists
    } = storeToRefs(useInvoiceTemplateStore());
    const {
      isGeneratingPdf,
      isPollingPdf
    } = storeToRefs(invoiceEditorStore);
    const {
      getTemplatesById,
      invoiceData,
      prepareInvoiceTemplateData,
      getTableFields,
      getCustomFields,
      updateInvoiceTemplate,
      createInvoiceTemplate,
      getServicesAndExpensesSummaryTemplates,
      updateServicesAndExpensesSummaryTemplates
    } = useInvoiceTemplateStore();
    const emit = __emit;
    const displayedPage = computed(() => props.serviceExpensePage ? 'Other Pages' : 'Invoice Template');
    const isTemplateNameDuplicate = computed(() => {
      if (props.serviceExpensePage || !updatePdfState.name || props.isTrainingFlow) {
        return false;
      }
      const trimmedName = updatePdfState.name.trim();
      if (!trimmedName) {
        return false;
      }

      // Check if any existing template has the same name (case-insensitive)
      return invoiceTemplateLists.value.some(template => {
        // For updates, exclude the current template being edited
        if (props.selectedInvoiceTemplate) {
          if (template.invoiceTemplateId && String(template.invoiceTemplateId) === String(props.selectedInvoiceTemplate)) {
            return false;
          }
        }
        return template.name?.toLowerCase() === trimmedName.toLowerCase();
      });
    });
    const showCustomFieldsBelowMatterOption = computed(() => features.value.llCustomFieldPdf && !props.isTrainingFlow && (updatePdfState.enableCustomFields || updatePdfState.enableMatterCustomFields));
    const disableSaveTemplate = computed(() => {
      if (props.serviceExpensePage || props.isTrainingFlow) {
        return false;
      }
      if (updatePdfState.invoicePdfDescription?.length > invoiceDescriptionMaxLenght) {
        return true;
      }
      const {
        formLabel
      } = updatePdfState.labelSettings || {};
      return features.value.invoiceRelabeling && (!formLabel || formLabel.length > 25);
    });

    // Stores original displayNames for columns renamed by the grouping toggle (BilledHours → Hrs/Qty,
    // LedesCodeDescription → Description). Kept outside field objects to prevent serialization into
    // the API payload via updateOrder()'s spread.
    const groupingRenamedFields = new Map();

    // Snapshot of tableFields/disabledTableFields taken just before grouping is enabled,
    // so they can be restored if the admin turns grouping back off.
    const savedTableFieldsBeforeGrouping = ref(null);

    // Whether grouping was already enabled when the template was loaded (so we only show the
    // destructive-action confirmation when the admin is enabling it for the first time this session).
    const groupingEnabledOnLoad = ref(false);
    const groupingConfirmDialog = ref(null);
    const GROUPING_FIXED_FIELD_NAMES = ['UserInitials', 'LedesCodeDescription', 'Rate', 'BilledHours', 'Amount'];
    const updatePdfState = reactive({
      loading: false,
      accountSummary: true,
      hourSummary: false,
      ledesSummary: false,
      trustSummary: true,
      displayTrustSummaryText: true,
      tableFields: [],
      tableData: [],
      disabledTableFields: [],
      disabledCustomFields: [],
      customFieldSettings: [],
      memo: '',
      contactInformation: '',
      enableInvoiceDescription: false,
      invoicePdfDescription: '',
      enableCustomFields: false,
      showExpenseAmountsOnly: false,
      hideFixedFeeDetail: false,
      groupingEnabled: false,
      enableSubTotal: false,
      errorMessage: '',
      enableClosingParagraph: false,
      closingParagraph: '',
      enableSegmentByType: false,
      enableSegmentByPracticeArea: false,
      enableOpeningParagraph: false,
      openingParagraph: '',
      templateOptions: [{
        label: 'Design',
        value: 'design'
      }, {
        label: 'Other Pages',
        value: 'otherPages'
      }],
      showInvoiceSummary: props.serviceExpensePage || false,
      servicesAndExpensesSummaryTemplates: {},
      enableServiceExpensePage: false,
      enableServiceExpenseByMatterPage: false,
      enablePaidStamp: false,
      enableDueDate: true,
      enableMatterName: false,
      enablePageNumbers: false,
      enableMatterHourSummary: false,
      enableMatterLedesSummary: false,
      enableMatterCustomFields: false,
      showCustomFieldsBelowMatterName: false,
      disabledMatterCustomFields: [],
      matterCustomFieldSettings: [],
      labelSettings: {
        enableFormLabel: true,
        formLabel: 'Invoice'
      },
      showEnableCustomFieldsToggle: true
    });
    const showCustomSortableModel = ref(false);
    const showMatterCustomSortableModel = ref(false);
    const showSortableTableModel = ref(false);
    const showSubscriptionCtaModal = ref(false);
    const subscriptionProcessing = ref(false);
    const originalTemplateState = ref({});

    // Training flow specific state
    const logoUploadState = reactive({
      resizedImage: '',
      fileName: '',
      uploading: false
    });
    const isDragOver = ref(false);
    const firmAddressForm = ref({
      contactInformation: ''
    });
    const companyNameForm = reactive({
      name: ''
    });
    const firmAddressSaving = ref(false);
    const companyNameSaving = ref(false);
    const isInitialized = ref(false);

    // Debounced auto-save for firm address
    let firmAddressTimeout = null;
    watch(() => updatePdfState.contactInformation, newValue => {
      if (!props.isTrainingFlow || !isInitialized.value) return;

      // Clear existing timeout
      if (firmAddressTimeout) {
        clearTimeout(firmAddressTimeout);
      }

      // Set new timeout for auto-save (2 seconds after user stops typing)
      firmAddressTimeout = setTimeout(() => {
        autoSaveFirmAddress();
      }, 2000);
    }, {
      deep: true
    });

    // Debounced auto-save for company name
    let companyNameTimeout = null;
    watch(() => companyNameForm.name, newValue => {
      if (!props.isTrainingFlow || !isInitialized.value) return;

      // Clear existing timeout
      if (companyNameTimeout) {
        clearTimeout(companyNameTimeout);
      }

      // Set new timeout for auto-save (2 seconds after user stops typing)
      companyNameTimeout = setTimeout(() => {
        autoSaveCompanyName();
      }, 2000);
    }, {
      deep: true
    });
    const restrictedColumns = ['BilledHours', 'WriteDownHours', 'Amount'];

    // Helper function to generate fieldsUpdatedBlob for tracking
    const generateFieldsUpdatedBlob = () => {
      const updatedFields = [];

      // Template name
      if (originalTemplateState.value.name !== updatePdfState.name) {
        updatedFields.push('templateName');
      }

      // Summaries (Account Summary, Trust Summary, Hour Summary)
      if (originalTemplateState.value.accountSummary !== updatePdfState.accountSummary) {
        updatedFields.push('summaries');
      }
      if (originalTemplateState.value.trustSummary !== updatePdfState.trustSummary) {
        updatedFields.push('summaries');
      }
      if (originalTemplateState.value.hourSummary !== updatePdfState.hourSummary) {
        updatedFields.push('summaries');
      }

      // Custom Fields (enabled, disabled, order)
      if (JSON.stringify(originalTemplateState.value.customFieldSettings) !== JSON.stringify(updatePdfState.customFieldSettings)) {
        updatedFields.push('customFields');
      }
      if (originalTemplateState.value.enableCustomFields !== updatePdfState.enableCustomFields) {
        updatedFields.push('customFields');
      }

      // Table fields (enabled, disabled, order)
      if (JSON.stringify(originalTemplateState.value.tableFields) !== JSON.stringify(updatePdfState.tableFields)) {
        updatedFields.push('tableFields');
      }

      // Memo
      if (originalTemplateState.value.memo !== updatePdfState.memo) {
        updatedFields.push('memo');
      }

      // Retainer vs Trust
      if (originalTemplateState.value.displayTrustSummaryText !== updatePdfState.displayTrustSummaryText) {
        updatedFields.push('retainerVsTrust');
      }

      // Paid Stamp
      if (originalTemplateState.value.enablePaidStamp !== updatePdfState.enablePaidStamp) {
        updatedFields.push('paidStamp');
      }

      // Remove duplicates and return
      const uniqueFields = [...new Set(updatedFields)];
      return JSON.stringify({
        fieldsUpdated: uniqueFields,
        totalFieldsChanged: uniqueFields.length
      });
    };
    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('click', handleClickOutsideForCustomFields);
      document.addEventListener('click', handleClickOutsideForMatterCustomFields);
      updatePdfState.loading = true;
      await Promise.all([meStore.getMe(), getTableFields(), getCustomFields(), companyStore.loadMyCompany(),
      // Always load company data for demo mode detection
      ...(props.isTrainingFlow ? [invoiceEmailStore.getInvoiceDeliveryDetail()] : [])]);

      // Initialize training flow specific data
      if (props.isTrainingFlow) {
        firmAddressForm.value.contactInformation = companySettings.value?.contactInformation || '';
        updatePdfState.contactInformation = companySettings.value?.contactInformation || '';

        // Initialize company name - add safe guard for name.value
        companyNameForm.name = name?.value || '';
      }
      loadInvoiceTableDate();
      if (props.selectedInvoiceTemplate) {
        await loadInvoiceTemplate();
        loadInvoiceTableDate();
      } else if (props.serviceExpensePage) {
        loadServicesAndExpensesSummaryTemplates();
      } else {
        const fieldOrder = ['InvoiceDate', 'Description', 'Rate', 'BilledHours', 'Amount'];
        const splitFields = tableFields.value.filter(f => f.fieldName !== 'LedesCodeDescription' || features.value.leedesInvoiceColumns).reduce((acc, field) => {
          if (fieldOrder.includes(field.fieldName)) {
            acc.enabled.push({
              ...field,
              isEnabled: true
            });
          } else {
            acc.disabled.push(field);
          }
          return acc;
        }, {
          enabled: [],
          disabled: []
        });

        // Sorting the enabled fields according to the predefined order
        updatePdfState.tableFields = splitFields.enabled.sort((a, b) => fieldOrder.indexOf(a.fieldName) - fieldOrder.indexOf(b.fieldName));
        updatePdfState.disabledTableFields = splitFields.disabled;
        updatePdfState.disabledCustomFields = updatePdfState.disabledMatterCustomFields = customFields.value;
      }
      updatePdfState.loading = false;
      isInitialized.value = true;
    });
    const onMove = evt => {
      if (updatePdfState.enableSubTotal && evt.relatedContext.index === 0 && restrictedColumns.includes(evt.draggedContext.element.fieldName)) {
        updatePdfState.errorMessage = `You cannot have ${evt.draggedContext.element.displayName} in the leftmost position while Sub-total by type is enabled because it causes improper alignment. Please re-arrange your columns and try again.`;
        handleError(updatePdfState.errorMessage);
        return;
      }
      updatePdfState.errorMessage = '';
      return true;
    };

    // Track columns modified when drag operation completes
    const onColumnDragEnd = evt => {
      // Only track if the item was actually moved to a different position
      if (evt.oldIndex !== evt.newIndex && props.tracking) {
        EventTracker.trackEvent(props.tracking, 'Invoice Template', 'Columns Modified', {
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
        });
      }
    };
    const updateFieldSettings = (fieldsList, settingsList, idKey) => {
      const enabledFields = fieldsList.filter(field => settingsList?.some(setting => setting[idKey] === field[idKey])).map(field => {
        const setting = settingsList.find(setting => setting[idKey] === field[idKey]);
        return {
          ...field,
          isEnabled: true,
          order: setting.order
        };
      }).sort((a, b) => a.order - b.order);
      const disabledFields = fieldsList.filter(field => !enabledFields.some(enabledField => enabledField[idKey] === field[idKey]));
      return {
        enabledFields,
        disabledFields
      };
    };
    const loadInvoiceTemplate = async () => {
      const invoiceTemplate = await getTemplatesById(props.selectedInvoiceTemplate);
      const {
        tableFieldSettings,
        customFieldSettings,
        matterCustomFieldSettings
      } = invoiceTemplate;
      const formattedInvoiceTemplateData = prepareInvoiceTemplateData(invoiceTemplate);
      Object.assign(updatePdfState, {
        ...formattedInvoiceTemplateData
      });
      groupingEnabledOnLoad.value = !!updatePdfState.groupingEnabled;

      // Store original state for tracking field changes
      originalTemplateState.value = JSON.parse(JSON.stringify({
        name: updatePdfState.name,
        accountSummary: updatePdfState.accountSummary,
        trustSummary: updatePdfState.trustSummary,
        hourSummary: updatePdfState.hourSummary,
        memo: updatePdfState.memo,
        displayTrustSummaryText: updatePdfState.displayTrustSummaryText,
        enableCustomFields: updatePdfState.enableCustomFields,
        enablePaidStamp: updatePdfState.enablePaidStamp,
        tableFields: updatePdfState.tableFields,
        customFieldSettings: updatePdfState.customFieldSettings
      }));

      // table fields
      const {
        enabledFields: enabledTableFields,
        disabledFields: rawDisabledTableFields
      } = updateFieldSettings(tableFields.value, tableFieldSettings, 'invoiceTemplateTableFieldId');
      if (!features.value.quantityInvoiceColumn) {
        // Grouping feature is off for this firm — restore pre-grouping behaviour exactly:
        // tableFields is untouched, disabledTableFields filtered by leedesInvoiceColumns only.
        updatePdfState.groupingEnabled = false;
        updatePdfState.tableFields = enabledTableFields;
        updatePdfState.disabledTableFields = features.value.leedesInvoiceColumns ? rawDisabledTableFields : rawDisabledTableFields.filter(f => f.fieldName !== 'LedesCodeDescription');
      } else {
        // Grouping feature is on — LedesCodeDescription visibility is gated by leedesInvoiceColumns
        // when grouping is off, and always shown (as a locked column) when grouping is on.
        const showLedesDesc = features.value.leedesInvoiceColumns || updatePdfState.groupingEnabled;
        updatePdfState.tableFields = showLedesDesc ? enabledTableFields : enabledTableFields.filter(f => f.fieldName !== 'LedesCodeDescription');
        updatePdfState.disabledTableFields = showLedesDesc ? rawDisabledTableFields : rawDisabledTableFields.filter(f => f.fieldName !== 'LedesCodeDescription');
      }
      if (updatePdfState.groupingEnabled) {
        const billedHours = updatePdfState.tableFields.find(f => f.fieldName === 'BilledHours');
        if (billedHours) {
          groupingRenamedFields.set('BilledHours', billedHours.displayName);
          billedHours.displayName = 'Hrs/Qty';
        }
        const ledesDesc = updatePdfState.tableFields.find(f => f.fieldName === 'LedesCodeDescription');
        if (ledesDesc) {
          groupingRenamedFields.set('LedesCodeDescription', ledesDesc.displayName);
          ledesDesc.displayName = 'LEDES Description';
        }
      }
      // custom fields
      const {
        enabledFields: enabledCustomFields,
        disabledFields: disabledCustomFields
      } = updateFieldSettings(customFields.value, customFieldSettings, 'customFieldId');
      updatePdfState.customFieldSettings = enabledCustomFields;
      updatePdfState.disabledCustomFields = disabledCustomFields;

      // matter custom fields
      const {
        enabledFields: enabledMatterCustomFields,
        disabledFields: disabledMatterCustomFields
      } = updateFieldSettings(customFields.value, matterCustomFieldSettings, 'customFieldId');
      updatePdfState.matterCustomFieldSettings = enabledMatterCustomFields;
      updatePdfState.disabledMatterCustomFields = disabledMatterCustomFields;
    };
    const loadServicesAndExpensesSummaryTemplates = async () => {
      updatePdfState.servicesAndExpensesSummaryTemplates = await getServicesAndExpensesSummaryTemplates();
      const {
        closingParagraph,
        enableClosingParagraph,
        enableOpeningParagraph,
        enableSegmentByPracticeArea,
        enableSegmentByType,
        openingParagraph,
        customFieldSettings
      } = updatePdfState.servicesAndExpensesSummaryTemplates;
      updatePdfState.closingParagraph = closingParagraph;
      updatePdfState.enableClosingParagraph = enableClosingParagraph;
      updatePdfState.enableOpeningParagraph = enableOpeningParagraph;
      updatePdfState.enableSegmentByPracticeArea = enableSegmentByPracticeArea;
      updatePdfState.enableSegmentByType = enableSegmentByType;
      updatePdfState.openingParagraph = openingParagraph;
      updatePdfState.showEnableCustomFieldsToggle = false;
      const {
        enabledFields: enabledCustomFields,
        disabledFields: disabledCustomFields
      } = updateFieldSettings(customFields.value, customFieldSettings, 'customFieldId');
      updatePdfState.customFieldSettings = enabledCustomFields;
      updatePdfState.disabledCustomFields = disabledCustomFields;
    };
    const handleClickOutside = event => {
      const actionMenuContainer = document.querySelector('.click-menu');
      if (!actionMenuContainer || actionMenuContainer.contains(event.target)) {
        // Click was inside the action menu container, do nothing
        return;
      }
      // Click was outside the action menu, close it
      showSortableTableModel.value = false;
    };
    const handleClickOutsideForCustomFields = event => {
      const actionMenuContainer = document.querySelector('.click-menu-custom-1');
      if (!actionMenuContainer || actionMenuContainer.contains(event.target)) {
        // Click was inside the action menu container, do nothing
        return;
      }
      // Click was outside the action menu, close it
      showCustomSortableModel.value = false;
    };
    const handleClickOutsideForMatterCustomFields = event => {
      const actionMenuContainer = document.querySelector('.click-menu-custom-2');
      if (!actionMenuContainer || actionMenuContainer.contains(event.target)) {
        // Click was inside the action menu container, do nothing
        return;
      }
      // Click was outside the action menu, close it
      showMatterCustomSortableModel.value = false;
    };
    const toggleClicked = value => {
      updatePdfState.showInvoiceSummary = value === 'otherPages';
      loadServicesAndExpensesSummaryTemplates();
    };
    const saveTemplate = async () => {
      if (props.serviceExpensePage) {
        saveServicesAndExpensesSummary();
        return;
      }

      // In training flow, save firm address first
      if (props.isTrainingFlow) {
        await updateFirmAddress();
      }

      // Validate template name only if not in training flow
      if (!props.isTrainingFlow) {
        if (!updatePdfState.name || !updatePdfState.name.trim()) {
          handleError('Template name is required.');
          return;
        }
        if (isTemplateNameDuplicate.value) {
          handleError('A template with this name already exists. Please choose a different name.');
          return;
        }
      } else {
        // In training flow, set a default name if none exists
        if (!updatePdfState.name || !updatePdfState.name.trim()) {
          updatePdfState.name = 'Training Template';
        }
      }
      if (updatePdfState.errorMessage) {
        handleError(updatePdfState.errorMessage);
        return;
      }

      // UI-009: show destructive-action confirmation when grouping is being enabled for the first time.
      if (updatePdfState.groupingEnabled && !groupingEnabledOnLoad.value) {
        const confirmed = await groupingConfirmDialog.value.open();
        if (!confirmed) {
          updatePdfState.groupingEnabled = false;
          onGroupingEnabledChange();
          return;
        }
      }
      if (props.selectedInvoiceTemplate) {
        updateInvoiceTemplateData();
        return;
      }
      createNewInvoiceTemplate();
    };
    const saveServicesAndExpensesSummary = async () => {
      updatePdfState.customFieldSettings = updateOrder(updatePdfState.customFieldSettings);
      const isCloseDialog = await updateServicesAndExpensesSummaryTemplates(updatePdfState.servicesAndExpensesSummaryTemplates.id, updatePdfState);
      if (isCloseDialog) {
        // Only show subscription CTA modal when in demo mode
        if (companySettings.value.demoMode && props.isTrainingFlow) {
          showSubscriptionCtaModal.value = true;
        } else {
          // Close the modal immediately if not in demo mode
          emit('closeDialog', true);
        }
      }
    };
    const updateInvoiceTemplateData = async () => {
      prepareTemplateData();
      const isCloseDialog = await updateInvoiceTemplate(props.selectedInvoiceTemplate, updatePdfState);
      if (!isCloseDialog) {
        // ERR-006: revert the grouping toggle if it was just enabled and the save failed.
        if (updatePdfState.groupingEnabled && !groupingEnabledOnLoad.value) {
          updatePdfState.groupingEnabled = false;
          onGroupingEnabledChange();
        }
        return;
      }
      // Track Invoice Template Saved event
      if (props.tracking) {
        props.tracking.event('Invoice Template', 'Saved', {
          templateId: props.selectedInvoiceTemplate,
          fieldsUpdatedBlob: generateFieldsUpdatedBlob(),
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
        });
      }

      // Only show subscription CTA modal when in demo mode
      if (companySettings.value.demoMode && props.isTrainingFlow) {
        showSubscriptionCtaModal.value = true;
      } else {
        // Close the modal immediately if not in demo mode
        emit('closeDialog', true);
      }
    };
    const canCreateMoreTemplates = () => {
      if (features.value.templatesUnlimited) {
        return true;
      }
      if (features.value.templates3) {
        return invoiceTemplateLists.value.length < 3;
      }
      return invoiceTemplateLists.value.length < 1;
    };
    const createNewInvoiceTemplate = async () => {
      if (!canCreateMoreTemplates()) {
        handleError('You have reached the maximum number of invoice templates.');
        return;
      }
      prepareTemplateData();
      const result = await createInvoiceTemplate(updatePdfState);
      if (result && result.invoiceTemplateId) {
        // Track Invoice Template Saved event
        if (props.tracking) {
          props.tracking.event('Invoice Template', 'Saved', {
            templateId: result.invoiceTemplateId,
            fieldsUpdatedBlob: JSON.stringify({
              fieldsUpdated: ['new_template'],
              totalFieldsChanged: 1,
              sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
            })
          });
        }

        // Only show subscription CTA modal when in demo mode
        if (companySettings.value.demoMode && props.isTrainingFlow) {
          showSubscriptionCtaModal.value = true;
        } else {
          // Close the modal immediately if not in demo mode
          emit('closeDialog', true);
        }
      }
    };
    const prepareTemplateData = () => {
      updatePdfState.tableFields = updateOrder(updatePdfState.tableFields);
      updatePdfState.customFieldSettings = updateOrder(updatePdfState.customFieldSettings);
      updatePdfState.matterCustomFieldSettings = updateOrder(updatePdfState.matterCustomFieldSettings);
    };
    const onGroupingEnabledChange = () => {
      if (updatePdfState.groupingEnabled) {
        // Save current column state so it can be restored if the toggle is turned off.
        savedTableFieldsBeforeGrouping.value = {
          tableFields: JSON.parse(JSON.stringify(updatePdfState.tableFields)),
          disabledTableFields: JSON.parse(JSON.stringify(updatePdfState.disabledTableFields))
        };

        // Resolve the fixed 5 columns from whatever is currently in state or the store catalogue.
        const allAvailable = [...updatePdfState.tableFields, ...updatePdfState.disabledTableFields, ...tableFields.value];
        const fixedFields = GROUPING_FIXED_FIELD_NAMES.map(fieldName => {
          const found = allAvailable.find(f => f.fieldName === fieldName);
          return found ? {
            ...found,
            isEnabled: true
          } : null;
        }).filter(Boolean);
        updatePdfState.tableFields = fixedFields;
        updatePdfState.disabledTableFields = [];

        // Rename BilledHours → Hrs/Qty and LedesCodeDescription → Description for the grouping context.
        const billedHours = updatePdfState.tableFields.find(f => f.fieldName === 'BilledHours');
        if (billedHours) {
          groupingRenamedFields.set('BilledHours', billedHours.displayName);
          billedHours.displayName = 'Hrs/Qty';
        }
        const ledesDesc = updatePdfState.tableFields.find(f => f.fieldName === 'LedesCodeDescription');
        if (ledesDesc) {
          groupingRenamedFields.set('LedesCodeDescription', ledesDesc.displayName);
          ledesDesc.displayName = 'LEDES Description';
        }
      } else {
        // Undo renames.
        const billedHours = updatePdfState.tableFields.find(f => f.fieldName === 'BilledHours');
        if (billedHours) {
          billedHours.displayName = groupingRenamedFields.get('BilledHours') ?? billedHours.displayName;
          groupingRenamedFields.delete('BilledHours');
        }
        const ledesDesc = updatePdfState.tableFields.find(f => f.fieldName === 'LedesCodeDescription');
        if (ledesDesc) {
          ledesDesc.displayName = groupingRenamedFields.get('LedesCodeDescription') ?? ledesDesc.displayName;
          groupingRenamedFields.delete('LedesCodeDescription');
        }

        // Restore the columns the admin had before enabling grouping.
        if (savedTableFieldsBeforeGrouping.value) {
          updatePdfState.tableFields = savedTableFieldsBeforeGrouping.value.tableFields;
          updatePdfState.disabledTableFields = savedTableFieldsBeforeGrouping.value.disabledTableFields;
          savedTableFieldsBeforeGrouping.value = null;
        }

        // When leedesInvoiceColumns is off, LedesCodeDescription is not user-selectable outside of
        // grouping mode — strip it from any restored state to prevent it surfacing in the picker.
        if (!features.value.leedesInvoiceColumns) {
          updatePdfState.tableFields = updatePdfState.tableFields.filter(f => f.fieldName !== 'LedesCodeDescription');
          updatePdfState.disabledTableFields = updatePdfState.disabledTableFields.filter(f => f.fieldName !== 'LedesCodeDescription');
        }
      }
    };
    const loadInvoiceTableDate = () => {
      updatePdfState.tableData = invoiceData(updatePdfState.showExpenseAmountsOnly, updatePdfState.enableMatterName, updatePdfState.hideFixedFeeDetail);
    };
    const toggleSubTotal = () => {
      const firstColumn = updatePdfState.tableFields[0].fieldName;
      if (restrictedColumns.includes(firstColumn)) {
        updatePdfState.errorMessage = `You cannot have ${updatePdfState.tableFields[0].displayName} in the leftmost position while Sub-total by type is enabled because it causes improper alignment. Please re-arrange your columns and try again.`;
        handleError(updatePdfState.errorMessage);
        updatePdfState.enableSubTotal = !updatePdfState.enableSubTotal;
        return;
      }
      updatePdfState.errorMessage = '';
    };

    // Training flow specific functions
    const getLogoFile = () => {
      const fileUpload = document.getElementById('logoFileInput');
      if (fileUpload != null) {
        fileUpload.click();
      }
    };
    const getLogoPreview = () => {
      if (logoUploadState.resizedImage.length > 0) {
        return logoUploadState.resizedImage;
      }
      if (invoiceEmailStore.invoiceDelivery?.logoUrl) {
        return `${props.leanLawAuth.domain}/v1/invoicedeliverysettings/logo`;
      }
      return '';
    };
    const resizeLogo = async event => {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      logoUploadState.fileName = files[0].name;
      logoUploadState.uploading = true;
      try {
        logoUploadState.resizedImage = await imageUtilities.createPreviewImage(files[0], 500, 374);
        await uploadLogo();
      } catch (error) {} finally {
        logoUploadState.uploading = false;
      }
    };
    const uploadLogo = async () => {
      if (!logoUploadState.resizedImage) return;
      const blobData = fileUtilities.createBlobData(logoUploadState.resizedImage, 'image/png');
      const data = new FormData();
      data.append('logo', blobData, logoUploadState.fileName);

      // Track logo upload event
      if (props.tracking) {
        props.tracking.event('Invoice Template', 'Logo Uploaded', {
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
        });
      }

      // Call the store method which handles its own success/error messages
      await invoiceEmailStore.sentImage(data);
    };

    // Drag and drop handlers for logo upload
    const onDragOver = event => {
      event.preventDefault();
      isDragOver.value = true;
    };
    const onDragLeave = event => {
      event.preventDefault();
      isDragOver.value = false;
    };
    const onDrop = async event => {
      event.preventDefault();
      isDragOver.value = false;
      const files = event.dataTransfer.files;
      if (!files.length) return;
      const file = files[0];

      // Validate file type
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        handleError('Only JPG and PNG files are allowed');
        return;
      }

      // Validate file size (2MB)
      if (file.size > 2 * 1024 * 1024) {
        handleError('File size must be less than 2MB');
        return;
      }
      logoUploadState.fileName = file.name;
      logoUploadState.uploading = true;
      try {
        logoUploadState.resizedImage = await imageUtilities.createPreviewImage(file, 500, 374);
        await uploadLogo();
      } catch (error) {} finally {
        logoUploadState.uploading = false;
      }
    };
    const updateFirmAddress = async () => {
      try {
        await companyStore.updateMyCompany({
          settings: {
            contactInformation: updatePdfState.contactInformation
          }
        });

        // Track address update event
        if (props.tracking) {
          props.tracking.event('Invoice Template', 'Address Updated', {
            sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
          });
        }

        // Show success feedback only when explicitly saving
        // (not during auto-save to avoid spamming notifications)
      } catch (error) {
        handleError('Failed to update firm address');
      }
    };

    // Auto-save firm address with debouncing
    const autoSaveFirmAddress = async () => {
      if (!props.isTrainingFlow || firmAddressSaving.value) return;
      firmAddressSaving.value = true;
      try {
        await companyStore.updateMyCompany({
          settings: {
            contactInformation: updatePdfState.contactInformation
          }
        });
      } catch (error) {
        // Silent failure for auto-save, user will see error on explicit save
      } finally {
        firmAddressSaving.value = false;
      }
    };
    const updateCompanyName = async () => {
      if (!companyNameForm.name?.trim()) return;
      companyNameSaving.value = true;
      try {
        // Get company ID from company store
        const companyId = companySettings.value?.id;
        if (!companyId) {
          handleError('Company ID not found');
          return;
        }

        // Use company store method to update company name
        await companyStore.updateCompanyName(companyId, companyNameForm.name);

        // Track company name update event
        if (props.tracking) {
          props.tracking.event('Invoice Template', 'Company Name Updated', {
            sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
          });
        }
      } catch (error) {
        handleError(error.message || 'Failed to update company name');
      } finally {
        companyNameSaving.value = false;
      }
    };

    // Auto-save company name with debouncing
    const autoSaveCompanyName = async () => {
      if (!props.isTrainingFlow || companyNameSaving.value || !companyNameForm.name?.trim()) return;

      // Get company ID from company store before setting saving state
      const companyId = company.value?.id;
      if (!companyId) {
        return;
      }
      companyNameSaving.value = true;
      try {
        // Use company store method to update company name
        await companyStore.updateCompanyName(companyId, companyNameForm.name);
        // Silent auto-save, no additional processing needed
      } catch (error) {
        // Silent failure for auto-save, user will see error on explicit save
      } finally {
        companyNameSaving.value = false;
      }
    };
    const previewInvoice = async () => {
      // Track preview download event when training flow is enabled
      if (props.isTrainingFlow && props.tracking) {
        props.tracking.event('Invoice Settings', 'Preview Downloaded', {
          templateId: props.selectedInvoiceTemplate || 'new_template',
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
        });
      }
      try {
        // First, save the template to ensure all changes are persisted
        // But don't trigger the subscription modal flow
        if (props.serviceExpensePage) {
          updatePdfState.customFieldSettings = updateOrder(updatePdfState.customFieldSettings);
          await updateServicesAndExpensesSummaryTemplates(updatePdfState.servicesAndExpensesSummaryTemplates.id, updatePdfState);
        } else {
          // In training flow, save firm address first
          if (props.isTrainingFlow) {
            await updateFirmAddress();
            // Set default name if none exists
            if (!updatePdfState.name || !updatePdfState.name.trim()) {
              updatePdfState.name = 'Training Template';
            }
          } else {
            // Validate template name for regular flow
            if (!updatePdfState.name || !updatePdfState.name.trim()) {
              handleError('Template name is required.');
              return;
            }
            if (isTemplateNameDuplicate.value) {
              handleError('A template with this name already exists. Please choose a different name.');
              return;
            }
          }
          if (updatePdfState.errorMessage) {
            handleError(updatePdfState.errorMessage);
            return;
          }

          // Save template without triggering subscription modal
          prepareTemplateData();
          if (props.selectedInvoiceTemplate) {
            await updateInvoiceTemplate(props.selectedInvoiceTemplate, updatePdfState);
          } else {
            if (!canCreateMoreTemplates()) {
              handleError('You have reached the maximum number of invoice templates.');
              return;
            }
            await createInvoiceTemplate(updatePdfState);
          }
        }
      } catch (error) {
        handleError('Failed to save template before generating preview.');
        return;
      }

      // Download the template preview - let the store handle its own errors
      try {
        await invoiceEditorStore.downloadInvoicePreview();

        // Track the action for analytics
        if (props.tracking) {
          props.tracking.track('Invoice Template Preview Downloaded', {
            sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings'
          });
        }
        handleSuccess('Invoice preview opened successfully');
      } catch (error) {
        // Store already handles error messages, just log for debugging
        console.error('Preview download failed:', error);
      }
    };

    // Continue to final invoice - saves template and shows subscription CTA modal
    const continueToFinalInvoice = async () => {
      try {
        // Save the template first - this will show the subscription CTA modal if in demo mode
        await saveTemplate();

        // Note: The saveTemplate() function now handles the subscription CTA modal display
        // and modal closing logic based on demo mode, so no additional logic needed here
      } catch (error) {
        handleError('Failed to save template. Please try again.');
      }
    };

    // Subscription CTA Modal handlers
    const handleSubscribeAndConnect = () => {
      // Track the subscription selection event in training flow
      if (props.isTrainingFlow && props.tracking) {
        props.tracking.event('Subscription CTA', 'Modal Viewed', {
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings',
          option: 'subscribeAndConnect'
        });
      }

      // Prevent multiple clicks
      if (subscriptionProcessing.value) {
        return;
      }
      subscriptionProcessing.value = true;

      // Close the subscription CTA modal first
      showSubscriptionCtaModal.value = false;

      // Emit event to tell InvoiceButtons to close the draft modal and open plan selection
      emit('close-draft-modal');

      // Close the template modal
      emit('closeDialog', true);
      subscriptionProcessing.value = false;
    };
    const handleScheduleCall = () => {
      // Track the schedule call selection event in training flow
      if (props.isTrainingFlow && props.tracking) {
        props.tracking.event('Subscription CTA', 'Option Selected', {
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings',
          option: 'scheduleCall'
        });
      }
      showSubscriptionCtaModal.value = false;
    };
    const handleSubscriptionCtaModalClose = () => {
      // Track modal abandonment in training flow
      if (props.isTrainingFlow && props.tracking) {
        props.tracking.event('Subscription CTA', 'Modal Abandoned', {
          sourceContext: props.isTrainingFlow ? 'trainingFlow' : 'regularSettings',
          abandonType: 'close'
        });
      }
      showSubscriptionCtaModal.value = false;
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_chip = _resolveComponent("v-chip");
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        class: "p-4 overflow-hidden",
        "data-cy": "invoice-create-template"
      }, {
        default: _withCtx(() => [updatePdfState.loading ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          what: displayedPage.value,
          class: "my-8"
        }, null, 8, ["what"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.isTrainingFlow ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[55] || (_cache[55] = [_createElementVNode("h2", {
          class: "text-xl font-semibold text-gray-800"
        }, " Invoice Template Setup ", -1), _createElementVNode("p", {
          class: "text-sm text-gray-600"
        }, " Customize your invoice template with your firm's information and preferred layout ", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(displayedPage.value), 1)), _createVNode(InvoiceTemplateTable, {
          updatePdfState: updatePdfState,
          serviceExpensePage: updatePdfState.showInvoiceSummary,
          companyName: companyNameForm.name,
          leanLawAuth: __props.leanLawAuth
        }, null, 8, ["updatePdfState", "serviceExpensePage", "companyName", "leanLawAuth"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          class: _normalizeClass(["flex p-4", [!__props.serviceExpensePage && _unref(features).invoiceSummaryPage && !__props.isTrainingFlow && !_unref(companySettings).demoMode ? 'justify-between' : 'justify-end']])
        }, [!__props.serviceExpensePage && _unref(features).invoiceSummaryPage && !__props.isTrainingFlow && !_unref(companySettings).demoMode ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(LlButtonToggle, {
          "model-value": updatePdfState.showInvoiceSummary ? 'otherPages' : 'design',
          items: updatePdfState.templateOptions,
          "aria-label": "Template pages",
          "onUpdate:modelValue": toggleClicked
        }, null, 8, ["model-value", "items"])])) : _createCommentVNode("", true), _createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('closeDialog', false), ["prevent"]))
        }, {
          default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })], 2), _createElementVNode("div", _hoisted_9, [!updatePdfState.showInvoiceSummary ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!__props.isTrainingFlow ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(LlTextField, {
          label: "Template Name",
          id: "at-to-field",
          type: "text",
          modelValue: updatePdfState.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updatePdfState.name = $event),
          "data-cy": "invoice-template-name-input",
          rules: [v => !!v || 'Template name is required.', v => v && v.trim() !== '' || 'Template name cannot be empty.', v => !isTemplateNameDuplicate.value || 'A template with this name already exists.'],
          "hide-details": false
        }, null, 8, ["modelValue", "rules"])])) : _createCommentVNode("", true), __props.isTrainingFlow ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[58] || (_cache[58] = _createTextVNode(" Firm Name ", -1)), companyNameSaving.value ? (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[57] || (_cache[57] = [_createElementVNode("i", {
          class: "fa fa-spinner fa-spin"
        }, null, -1), _createTextVNode(" Saving... ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createVNode(LlTextField, {
          label: "",
          "hide-details": "true",
          modelValue: companyNameForm.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => companyNameForm.name = $event),
          placeholder: "Enter your company/firm name",
          "data-cy": "company-name-input"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[60] || (_cache[60] = _createTextVNode(" Firm Address ", -1)), firmAddressSaving.value ? (_openBlock(), _createElementBlock("span", _hoisted_20, [...(_cache[59] || (_cache[59] = [_createElementVNode("i", {
          class: "fa fa-spinner fa-spin"
        }, null, -1), _createTextVNode(" Saving... ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createVNode(LlTextarea, {
          label: "",
          "hide-details": "true",
          modelValue: updatePdfState.contactInformation,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => updatePdfState.contactInformation = $event),
          placeholder: "Enter your firm's address and contact information as it should appear on invoices",
          rows: "6"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_22, [_cache[63] || (_cache[63] = _createElementVNode("div", {
          class: "text-base py-2"
        }, "Firm Logo", -1)), _createElementVNode("div", {
          class: _normalizeClass(["border-2 border-dashed border-[rgb(var(--v-theme-primary))] rounded-lg p-4 text-center cursor-pointer hover:border-[rgb(var(--v-theme-primary-darken-1))] transition-colors", {
            'border-[rgb(var(--v-theme-primary-darken-1))] bg-green-50': isDragOver.value
          }]),
          onClick: _cache[4] || (_cache[4] = $event => getLogoFile()),
          onDragover: _withModifiers(onDragOver, ["prevent"]),
          onDragleave: _withModifiers(onDragLeave, ["prevent"]),
          onDrop: _withModifiers(onDrop, ["prevent"])
        }, [logoUploadState.resizedImage || _unref(invoiceEmailStore).invoiceDelivery?.logoUrl ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("img", {
          src: getLogoPreview(),
          class: "max-w-full max-h-20 object-contain mx-auto"
        }, null, 8, _hoisted_24)])) : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[61] || (_cache[61] = [_createElementVNode("div", {
          class: "mb-3"
        }, [_createElementVNode("i", {
          class: "fa fa-camera text-gray-400 text-3xl"
        })], -1), _createElementVNode("div", {
          class: "text-gray-600 text-sm font-medium"
        }, " LOGO ", -1)]))]))], 34), _createElementVNode("div", _hoisted_26, [_cache[62] || (_cache[62] = _createElementVNode("span", {
          class: "font-bold"
        }, "Drag and drop your logo or", -1)), _createElementVNode("span", {
          class: "text-primary hover:!text-[rgb(var(--v-theme-primary-darken-1))] cursor-pointer font-medium",
          onClick: _cache[5] || (_cache[5] = $event => getLogoFile())
        }, " Browse files ")]), _cache[64] || (_cache[64] = _createElementVNode("div", {
          class: "text-xs text-gray-500"
        }, [_createTextVNode(" JPG and PNG files are allowed (Maximum size 2MB)"), _createElementVNode("br"), _createTextVNode(" The recommended maximum size is 500px wide and 374px tall. ")], -1)), _createElementVNode("input", {
          type: "file",
          class: "hidden",
          id: "logoFileInput",
          accept: "image/*",
          onChange: _cache[6] || (_cache[6] = $event => resizeLogo($event))
        }, null, 32)])])])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[67] || (_cache[67] = _createElementVNode("hr", {
          style: {
            "margin": "4px"
          }
        }, null, -1)), _createElementVNode("div", _hoisted_27, [updatePdfState.enableServiceExpenseByMatterPage ? (_openBlock(), _createElementBlock("span", _hoisted_28, [_cache[66] || (_cache[66] = _createTextVNode("Invoice Settings ", -1)), _createVNode(LlTooltip, {
          icon: "help"
        }, {
          default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode(" When using an index page template on a single-matter invoice, invoice and matter custom fields appear in a unified header with invoice fields first, followed by matter fields.", -1)]))]),
          _: 1
        })])) : (_openBlock(), _createElementBlock("span", _hoisted_29, "Summary Selection"))]), _withDirectives(_createElementVNode("div", _hoisted_30, " Apply to the overall invoice and control the details on the first page ", 512), [[_vShow, updatePdfState.enableServiceExpenseByMatterPage]]), _createElementVNode("div", _hoisted_31, [_createVNode(LlSwitch, {
          label: "Account Summary",
          "data-cy": "account-summary-switch",
          disabled: updatePdfState.enableServiceExpenseByMatterPage,
          modelValue: updatePdfState.accountSummary,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => updatePdfState.accountSummary = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(LlSwitch, {
          label: updatePdfState.displayTrustSummaryText ? 'Trust Summary' : 'Retainer Summary',
          "data-cy": "trust-summary-switch",
          modelValue: updatePdfState.trustSummary,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => updatePdfState.trustSummary = $event)
        }, null, 8, ["label", "modelValue"]), _createVNode(LlSwitch, {
          label: "Hours Summary",
          "data-cy": "hours-summary-switch",
          disabled: updatePdfState.enableServiceExpenseByMatterPage,
          modelValue: updatePdfState.hourSummary,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => updatePdfState.hourSummary = $event)
        }, null, 8, ["disabled", "modelValue"]), _unref(features).codeSummary ? (_openBlock(), _createBlock(LlSwitch, {
          key: 0,
          label: "LEDES Summary",
          "data-cy": "ledes-summary-switch",
          disabled: updatePdfState.enableServiceExpenseByMatterPage,
          modelValue: updatePdfState.ledesSummary,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => updatePdfState.ledesSummary = $event)
        }, null, 8, ["disabled", "modelValue"])) : _createCommentVNode("", true)])]), !__props.isTrainingFlow ? (_openBlock(), _createBlock(CustomFields, {
          key: 2,
          updatePdfState: updatePdfState,
          enable: updatePdfState.enableCustomFields,
          state: __props.state,
          showBorder: true,
          onCloseDialog: _cache[11] || (_cache[11] = $event => _ctx.$emit('closeDialog', true)),
          showSortableModel: showCustomSortableModel.value,
          onToggleConfigureFields: _cache[12] || (_cache[12] = $event => showCustomSortableModel.value = !showCustomSortableModel.value),
          "onUpdate:enable": _cache[13] || (_cache[13] = $event => updatePdfState.enableCustomFields = $event)
        }, null, 8, ["updatePdfState", "enable", "state", "showSortableModel"])) : _createCommentVNode("", true), showCustomFieldsBelowMatterOption.value ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(LlSwitch, {
          label: "Show custom fields below matter name",
          info: "When enabled, custom fields display below the matter name on each matter page instead of in the invoice header.",
          "data-cy": "show-custom-fields-below-matter-name-switch",
          modelValue: updatePdfState.showCustomFieldsBelowMatterName,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => updatePdfState.showCustomFieldsBelowMatterName = $event)
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [updatePdfState.enableServiceExpenseByMatterPage ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_unref(terms)?.Matter) + " Settings ", 1), _createElementVNode("div", null, "Apply to the " + _toDisplayString(_unref(terms)?.Matter) + " invoice", 1), _createElementVNode("div", _hoisted_36, [_createVNode(LlSwitch, {
          label: "Hours Summary",
          modelValue: updatePdfState.enableMatterHourSummary,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => updatePdfState.enableMatterHourSummary = $event)
        }, null, 8, ["modelValue"]), _unref(features).codeSummary ? (_openBlock(), _createBlock(LlSwitch, {
          key: 0,
          label: "LEDES Summary",
          "data-cy": "matter-ledes-summary-switch",
          modelValue: updatePdfState.enableMatterLedesSummary,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => updatePdfState.enableMatterLedesSummary = $event)
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]), _createVNode(MatterCustomFields, {
          updatePdfState: updatePdfState,
          enable: updatePdfState.enableMatterCustomFields,
          state: __props.state,
          showBorder: true,
          showSortableModel: showMatterCustomSortableModel.value,
          onToggleConfigureFields: _cache[17] || (_cache[17] = $event => showMatterCustomSortableModel.value = !showMatterCustomSortableModel.value),
          onCloseDialog: _cache[18] || (_cache[18] = $event => _ctx.$emit('closeDialog', true)),
          "onUpdate:enable": _cache[19] || (_cache[19] = $event => updatePdfState.enableMatterCustomFields = $event)
        }, null, 8, ["updatePdfState", "enable", "state", "showSortableModel"])])) : _createCommentVNode("", true)]), _createVNode(TableFields, {
          updatePdfState: updatePdfState,
          showSortableModel: showSortableTableModel.value,
          tracking: __props.tracking,
          isTrainingFlow: __props.isTrainingFlow,
          groupingEnabled: updatePdfState.groupingEnabled,
          onToggleConfigureFields: _cache[20] || (_cache[20] = $event => showSortableTableModel.value = !showSortableTableModel.value)
        }, null, 8, ["updatePdfState", "showSortableModel", "tracking", "isTrainingFlow", "groupingEnabled"]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, [_createVNode(_unref(draggable), {
          modelValue: updatePdfState.tableFields,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => updatePdfState.tableFields = $event),
          tag: "tr",
          class: "overflow-x-auto",
          "item-key": key => key,
          move: onMove,
          onEnd: onColumnDragEnd,
          disabled: updatePdfState.groupingEnabled
        }, {
          item: _withCtx(({
            element: header
          }) => [_createElementVNode("th", _hoisted_38, [_createVNode(_component_v_chip, {
            class: _normalizeClass(["mx-1", updatePdfState.groupingEnabled ? 'cursor-default' : 'cursor-pointer']),
            label: ""
          }, {
            default: _withCtx(() => [!updatePdfState.groupingEnabled ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0
            }, {
              default: _withCtx(() => [...(_cache[68] || (_cache[68] = [_createTextVNode("mdi-drag", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(header.displayName), 1)]),
            _: 2
          }, 1032, ["class"])])]),
          _: 1
        }, 8, ["modelValue", "item-key", "disabled"])]), _createElementVNode("div", _hoisted_39, [_createVNode(LlSwitch, {
          modelValue: updatePdfState.showExpenseAmountsOnly,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => updatePdfState.showExpenseAmountsOnly = $event),
          label: "Show only expense amounts",
          onChange: _cache[23] || (_cache[23] = $event => loadInvoiceTableDate())
        }, null, 8, ["modelValue"]), _createVNode(LlSwitch, {
          modelValue: updatePdfState.enableSubTotal,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => updatePdfState.enableSubTotal = $event),
          label: "Sub-total by type",
          onChange: _cache[25] || (_cache[25] = $event => {
            toggleSubTotal();
            loadInvoiceTableDate();
          })
        }, null, 8, ["modelValue"])])]), _unref(features).fixedFeeRevenueAllocation ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_cache[69] || (_cache[69] = _createElementVNode("hr", {
          style: {
            "margin": "1px"
          }
        }, null, -1)), _cache[70] || (_cache[70] = _createElementVNode("div", {
          class: "text-base py-2"
        }, "Section Options", -1)), _createElementVNode("div", _hoisted_41, [_createVNode(LlSwitch, {
          modelValue: updatePdfState.hideFixedFeeDetail,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => updatePdfState.hideFixedFeeDetail = $event),
          label: "Hide fixed fee detail",
          onChange: _cache[27] || (_cache[27] = $event => loadInvoiceTableDate())
        }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _unref(features).quantityInvoiceColumn ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[71] || (_cache[71] = _createElementVNode("hr", {
          class: "m-1"
        }, null, -1)), _cache[72] || (_cache[72] = _createElementVNode("div", {
          class: "text-base py-2"
        }, "Grouping", -1)), _createElementVNode("div", _hoisted_43, [_createVNode(LlSwitch, {
          modelValue: updatePdfState.groupingEnabled,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => updatePdfState.groupingEnabled = $event),
          label: "Group line items",
          onChange: onGroupingEnabledChange
        }, null, 8, ["modelValue"])]), updatePdfState.groupingEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Column layout is fixed when grouping is enabled. Any previously selected columns are discarded and will not be restored if grouping is turned off. ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !__props.isTrainingFlow ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_cache[73] || (_cache[73] = _createElementVNode("hr", {
          style: {
            "margin": "1px"
          }
        }, null, -1)), _createElementVNode("div", _hoisted_46, [_createVNode(LlSwitch, {
          label: "Invoice Description",
          modelValue: updatePdfState.enableInvoiceDescription,
          "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => updatePdfState.enableInvoiceDescription = $event)
        }, null, 8, ["modelValue"])]), _withDirectives(_createVNode(_component_v_textarea, {
          modelValue: updatePdfState.invoicePdfDescription,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => updatePdfState.invoicePdfDescription = $event),
          rows: "3",
          variant: "outlined",
          "data-cy": "invoice-description-input",
          rules: [v => (v ? v.length <= invoiceDescriptionMaxLenght : true) || 'Description cannot exceed 4095 characters.']
        }, null, 8, ["modelValue", "rules"]), [[_vShow, updatePdfState.enableInvoiceDescription]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_47, [_cache[74] || (_cache[74] = _createElementVNode("hr", {
          style: {
            "margin": "1px"
          }
        }, null, -1)), _cache[75] || (_cache[75] = _createElementVNode("label", {
          class: "text-base py-2"
        }, "Memo", -1)), _createVNode(_component_v_textarea, {
          modelValue: updatePdfState.memo,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => updatePdfState.memo = $event),
          rows: "3",
          variant: "outlined",
          "hide-details": "true",
          "data-cy": "invoice-memo-input"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_48, [_cache[76] || (_cache[76] = _createElementVNode("hr", {
          style: {
            "margin": "1px"
          }
        }, null, -1)), _cache[77] || (_cache[77] = _createElementVNode("div", {
          class: "text-base py-2"
        }, " Trust or Retainer Mode Configuration ", -1)), _createElementVNode("div", _hoisted_49, [_createElementVNode("label", {
          onClick: _cache[32] || (_cache[32] = $event => updatePdfState.displayTrustSummaryText = false),
          class: _normalizeClass(["px-2 pt-1 text-base", {
            'text-primary': !updatePdfState.displayTrustSummaryText
          }])
        }, " Retainer ", 2), _createVNode(LlSwitch, {
          modelValue: updatePdfState.displayTrustSummaryText,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => updatePdfState.displayTrustSummaryText = $event)
        }, null, 8, ["modelValue"]), _createElementVNode("label", {
          onClick: _cache[34] || (_cache[34] = $event => updatePdfState.displayTrustSummaryText = true),
          class: _normalizeClass(["px-2 pt-1 text-base", {
            'text-primary': updatePdfState.displayTrustSummaryText
          }])
        }, " Trust ", 2)])]), _unref(features).indexPagePDF || _unref(features).invoiceRelabeling || _unref(features).leanlawInvoice ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_cache[78] || (_cache[78] = _createElementVNode("hr", {
          style: {
            "margin": "1px"
          }
        }, null, -1)), _cache[79] || (_cache[79] = _createElementVNode("div", {
          class: "text-base py-2"
        }, "Additional Options", -1)), _unref(features).invoiceRelabeling ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createVNode(LlSwitch, {
          label: "Form label",
          hideDetails: false,
          modelValue: updatePdfState.labelSettings.enableFormLabel,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => updatePdfState.labelSettings.enableFormLabel = $event)
        }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
          type: "text",
          modelValue: updatePdfState.labelSettings.formLabel,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => updatePdfState.labelSettings.formLabel = $event),
          hideDetails: false,
          rules: [v => !!v || 'Form label cannot be blank.', v => v.length <= 25 || 'Form label cannot exceed 25 characters.']
        }, null, 8, ["modelValue", "rules"])])) : _createCommentVNode("", true), _unref(features).indexPagePDF ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(LlSwitch, {
          label: "Due Date",
          modelValue: updatePdfState.enableDueDate,
          "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => updatePdfState.enableDueDate = $event),
          hideDetails: false
        }, null, 8, ["modelValue"]), _createVNode(LlSwitch, {
          label: "Enable Paid Stamp",
          modelValue: updatePdfState.enablePaidStamp,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => updatePdfState.enablePaidStamp = $event),
          hideDetails: false
        }, null, 8, ["modelValue"]), _createVNode(LlSwitch, {
          label: "Matter Name",
          modelValue: updatePdfState.enableMatterName,
          "onUpdate:modelValue": [_cache[39] || (_cache[39] = $event => updatePdfState.enableMatterName = $event), _cache[40] || (_cache[40] = $event => loadInvoiceTableDate())],
          hideDetails: false
        }, null, 8, ["modelValue"]), _createVNode(LlSwitch, {
          label: "Page Numbers",
          modelValue: updatePdfState.enablePageNumbers,
          "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => updatePdfState.enablePageNumbers = $event),
          hideDetails: false
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), !_unref(features).indexPagePDF ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createVNode(LlSwitch, {
          label: "Due Date",
          modelValue: updatePdfState.enableDueDate,
          "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => updatePdfState.enableDueDate = $event)
        }, null, 8, ["modelValue"]), _createVNode(LlSwitch, {
          label: "Enable Paid Stamp",
          modelValue: updatePdfState.enablePaidStamp,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => updatePdfState.enablePaidStamp = $event)
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64)) : !__props.serviceExpensePage ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createVNode(LlSwitch, {
          label: "Services & Expenses As Cover Page",
          modelValue: updatePdfState.enableServiceExpensePage,
          "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => updatePdfState.enableServiceExpensePage = $event)
        }, null, 8, ["modelValue"]), _unref(features).indexPagePDF ? (_openBlock(), _createBlock(LlSwitch, {
          key: 0,
          label: "Services & Expenses By Matter As Index Page",
          modelValue: updatePdfState.enableServiceExpenseByMatterPage,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => updatePdfState.enableServiceExpenseByMatterPage = $event)
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.serviceExpensePage ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createVNode(CustomFields, {
          updatePdfState: updatePdfState,
          enable: updatePdfState.enableCustomFields,
          state: __props.state,
          onCloseDialog: _cache[46] || (_cache[46] = $event => _ctx.$emit('closeDialog', true)),
          showSortableModel: showCustomSortableModel.value,
          onToggleConfigureFields: _cache[47] || (_cache[47] = $event => showCustomSortableModel.value = !showCustomSortableModel.value),
          "onUpdate:enable": _cache[48] || (_cache[48] = $event => updatePdfState.enableCustomFields = $event)
        }, null, 8, ["updatePdfState", "enable", "state", "showSortableModel"]), _createVNode(ServiceAndExpenseSettings, {
          updatePdfState: updatePdfState
        }, null, 8, ["updatePdfState"])], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_55, [__props.isTrainingFlow ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(LlSecondaryButton, {
          variant: "outlined",
          "data-cy": "close-training",
          onBtnClick: _cache[49] || (_cache[49] = $event => _ctx.$emit('closeDialog', false))
        }, {
          default: _withCtx(() => [...(_cache[80] || (_cache[80] = [_createTextVNode(" Close ", -1)]))]),
          _: 1
        }), _createVNode(LlSecondaryButton, {
          color: "primary",
          "data-cy": "download-preview",
          onBtnClick: _cache[50] || (_cache[50] = $event => previewInvoice()),
          isSaving: _unref(isGeneratingPdf) || _unref(isPollingPdf)
        }, {
          default: _withCtx(() => [_unref(isGeneratingPdf) ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Generating...")) : _unref(isPollingPdf) ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Preparing...")) : (_openBlock(), _createElementBlock("span", _hoisted_58, "Download Preview"))]),
          _: 1
        }, 8, ["isSaving"]), _createVNode(LlSecondaryButton, {
          color: "primary",
          "data-cy": "continue-training",
          onBtnClick: _cache[51] || (_cache[51] = $event => continueToFinalInvoice())
        }, {
          default: _withCtx(() => [...(_cache[81] || (_cache[81] = [_createTextVNode(" Continue ", -1)]))]),
          _: 1
        })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(LlSecondaryButton, {
          variant: "outlined",
          "data-cy": "cancel-template",
          onBtnClick: _cache[52] || (_cache[52] = $event => _ctx.$emit('closeDialog', false))
        }, {
          default: _withCtx(() => [...(_cache[82] || (_cache[82] = [_createTextVNode(" Close ", -1)]))]),
          _: 1
        }), _createVNode(LlSecondaryButton, {
          color: "primary",
          disabled: disableSaveTemplate.value || !!updatePdfState.errorMessage,
          "data-cy": "save-template",
          onBtnClick: _cache[53] || (_cache[53] = $event => saveTemplate())
        }, {
          default: _withCtx(() => [...(_cache[83] || (_cache[83] = [_createTextVNode("Save Template", -1)]))]),
          _: 1
        }, 8, ["disabled"])], 64))])])])])), _createVNode(SubscriptionCtaModal, {
          modelValue: showSubscriptionCtaModal.value,
          "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => showSubscriptionCtaModal.value = $event),
          onSubscribeAndConnect: handleSubscribeAndConnect,
          onScheduleCall: handleScheduleCall,
          onClose: handleSubscriptionCtaModalClose
        }, null, 8, ["modelValue"]), _createVNode(LlConfirmationDialog, {
          ref_key: "groupingConfirmDialog",
          ref: groupingConfirmDialog,
          title: "Enable grouping?",
          message: "Enabling grouping replaces this template's columns with the fixed 5 and permanently discards your current columns. They cannot be restored. Continue?",
          confirmText: "Continue",
          toggleText: "Cancel",
          confirmColor: "primary",
          "data-cy": "grouping-confirmation-dialog"
        }, null, 512)]),
        _: 1
      });
    };
  }
};